import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 23,
    type: CHECKLIST_ITEM_TYPE.LEAD_STATUS_CHANGED,
    manifestKey: 'LEAD_STATUS_CHANGED',

    try_it: {
        button_label: 'Change Lead Status',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'LeadStatusChangedCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: {},
            target_status: 'CONSULTATION_BOOKED',
        },
    },
    pre_flight_diff: [
        'Step 1: POST /lead-treatments/{lt_pk}/transition/ with target_status',
        'LeadTreatment status changes per BE FSM',
        'Step 2: POST /checklist/{iid}/complete/ — checklist item: PENDING → YES',
        '⚠ FE/BE graph mismatch: FE may show transitions (e.g. FAILED_TO_ATTEND → NEW) that BE FSM rejects with 400',
        'Role gate: ADMIN or TCO only — USER role returns 403',
    ],
    has_step2_throttle: true,
    validation_laboratory: [
        {
            label: 'Transition FAILED_TO_ATTEND → NEW (FE allows, BE rejects)',
            body: { target_status: 'NEW' },
            expected: '400 from BE FSM — FE graph shows this as valid option but BE rejects it (out-of-scope ticket #4)',
        },
        {
            label: 'Multi-step skip: NEW → TREATMENT_STARTED',
            body: { target_status: 'TREATMENT_STARTED' },
            expected: '400 — FSM rejects non-adjacent transition',
        },
    ],
};
